import { useTranslation } from 'react-i18next';
import { Button } from '../common';

export default function SearchButton({ onClick }) {
  const { t } = useTranslation();
  return (
    <div>
      {/* #249: 검색 CTA 강조 — Button 기본 text-sm 를 이기도록 ! 강제(text-[15px]). */}
      <Button width="responsive-lg-130" onClick={onClick} className="!text-[15px]">{t('common.search')}</Button>
    </div>
  );
}
